export function init_add_cart() {
// 買い物カゴにカタログ商品を入れる
  // 同意必須カタログ商品コード初期値
  let agreed_catalog_item_cds = [];
  let checked_duplicate_agreed_catalog_item_cds = String($('.js-agree_catalog_items').data('val')).split(",");

// 商品詳細_買い物カゴに入れるボタン
  // 買い物カゴに入れるボタンを押下時、発火
  $('.js-add-cart').on("click", function(e) {
    // 買い物カゴに入れるカタログ商品情報を格納
    let item = $(this).data('item');
    item['amount'] = $(".js-input-amount").val();

    if(item['amount'] < 1){
      alert('数量には1以上を指定してください');
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    const target_modal = '#modalAgree';

    if ( skip_agreement(item) ) {
      // 商品を買い物カゴに入れましたモーダルをtargetに格納する
      const target = $('#modalCartIn').html();
      // 同意モーダルをtargetに入れ替え表示
      $(target_modal).html(target).fadeIn();

      add_cart(item, false, target_modal);

    } else {
      $(`${target_modal} .js-add-cart-via-agreement`).data('item', item);
    }
  });

  // 一括で買い物カゴに入れるボタンを押下時、発火
  $('.js-add-cart-in-bulk').on("click", function() {
    const $input_amounts = $("input[name='js-variation-table-input']");
    const agreement_required_items = set_agreement_required_items($input_amounts);
    const orderd_items = set_orderd_items($input_amounts);

    if ( agreement_required_items.length ) {
      // カートに入れる商品を data 属性にセット
      $('.js-agreement-in-bulk-button').data('orderd-items', orderd_items);

      prepare_agreement_message_in_bulk(agreement_required_items);
      open_agreement_in_bulk_modal();
    } else {
      // 同意が必要なかった場合
      $.ajax({
        type: 'POST',
        url: '/add_cart_in_bulk',
        data: {
          shop_slug: $(this).data('shop-slug'),
          catalog_items: orderd_items,
        }
      })
      .done(function(data) {
        // カート追加済みモーダル開く
        open_cart_in_bulk_modal(data);
        reload_cart_items();
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        if (textStatus === 'abort') return;
        close_agreement_in_bulk_modal();
        alert('正しく反映されませんでした。画面を更新してください。')
      });
    }

    return false;
  });

  // 他のバリエーション_買い物カゴに入れるボタンを押下時、発火
  $('.js-add-cart-catalog-item-variation-button').on("click", function(e) {
    // 買い物カゴに入れるカタログ商品情報を格納
    let item = $(this).data('item');
    item['amount'] = $(this).closest('.js-variation-cart-button').find('input').val();

    if(item['amount'] < 1){
      alert('数量には1以上を指定してください');
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    const target_modal = `#modalAgreeInOtherVariation${item['catalog-item-cd']}`

    if ( skip_agreement(item) ) {
      // 商品を買い物カゴに入れましたモーダルをtargetに格納する
      const target = $(`#modalCartIn${item['catalog-item-cd']}`).html();
      // 同意モーダルをtargetに入れ替え表示
      $(target_modal).html(target).fadeIn();

      add_cart(item, false, target_modal);
    } else {
      $(`${target_modal} .js-add-cart-via-agreement`).data('item', item);
    }
  });

  // お気に入り_買い物カゴに入れるボタンを押下時、発火
  $('.js-add-cart-favorite-button').on("click", function(e) {
    // 買い物カゴに入れるカタログ商品情報を格納
    let item = $(this).data('item');
    item['amount'] = $(this).closest('.js-favorite-cart-button').find('input').val();

    if(item['amount'] < 1){
      alert('数量には1以上を指定してください');
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    const target_modal = `#modalAgreeFavorite${item['catalog-item-cd']}`

    if ( skip_agreement(item) ) {
      // 商品を買い物カゴに入れましたモーダルをtargetに格納する
      const target = $(`#modalCartIn${item['catalog-item-cd']}`).html();
      // 同意モーダルをtargetに入れ替え表示
      $(target_modal).html(target).fadeIn();

      add_cart(item, false, target_modal);
    } else {
      $(`${target_modal} .js-add-cart-via-agreement`).data('item', item);
    }
  });

  // 購入履歴_買い物カゴに入れるボタンを押下時、発火
  $('.js-add-cart-purchase-history-button').on("click", function() {
    // 買い物カゴに入れるカタログ商品情報を格納
    let item = $(this).data('item');
    item['amount'] = '1';

    const target_modal = `#modalAgreePurchaseHistory${item['catalog-item-cd']}`

    if ( skip_agreement(item) ) {
      // 商品を買い物カゴに入れましたモーダルをtargetに格納する
      const target = $(`#modalCartIn${item['catalog-item-cd']}`).html();
      // 同意モーダルをtargetに入れ替え表示
      $(target_modal).html(target).fadeIn();

      add_cart(item, false, target_modal);
    } else {
      $(`${target_modal} .js-add-cart-via-agreement`).data('item', item);
    }
  });

  // カセット_買い物カゴに入れるボタンを押下時、発火
  $('.js-add-cart-cassette-button').on("click", onclick_add_cart);

  function onclick_add_cart(event) {
    // 買い物カゴに入れるカタログ商品情報を格納
    let item = $(event.currentTarget).data('item');
    item['amount'] = '1';

    const target_modal = `#modalAgreeInCassette${item['catalog-item-cd']}`

    if ( skip_agreement(item) ) {
      // 商品を買い物カゴに入れましたモーダルをtargetに格納する
      const target = $(`#modalCartIn${item['catalog-item-cd']}`).html();
      // 同意モーダルをtargetに入れ替え表示
      $(target_modal).html(target).fadeIn();

      // サンプル商品かどうかをitemのデータで判定
      const is_sample = item['is-sample'] === true;
      add_cart(item, false, target_modal, is_sample);
    } else {
      $(`${target_modal} .js-add-cart-via-agreement`).data('item', item);
    }
  }

  // クイックオーダー_一括で買い物カゴに入れるで発火
  $('.js-add-cart-quick-order').on("click", function() {
    const $input_amounts = $('.js-item-amount');
    const agreement_required_items = set_agreement_required_items($input_amounts);

    // 1つでも0以下の値があればエラー扱い
    let less_than_zero = false;
    $input_amounts.each(function(i, e) {
      const amount = $(e).val();
      if( amount < 1 && $(e).data('item')){
        less_than_zero = true;
        return false;
      }
    });
    if(less_than_zero){
      alert('数量には1以上を指定してください');
      return;
    }

    if ( agreement_required_items.length ) {
      prepare_agreement_message_in_bulk(agreement_required_items);
      open_agreement_in_bulk_modal();

      return false;
    }

    $('form#quick_order').submit();

    return false;
  });

  // 単品_同意必須モーダル_同意した上で買い物カゴに入れるで発火
  $(document).on("click", '.js-add-cart-via-agreement', function() {
    const item = $(this).data('item');

    // サンプル商品かどうかをitemのデータで判定
    const is_sample = item['is-sample'] === true;

    add_cart(item, true, false, is_sample);
  });

  // 一括_同意必須モーダル_同意した上で買い物カゴに入れるで発火
  $('#modalAgreementInBulk .js-agreement-in-bulk-button').on("click", function(e) {
    after_agreement($(this).data('agreement-required-item-codes'));

    $.ajax({
      type: 'POST',
      url: '/add_cart_in_bulk',
      data: {
        shop_slug: $(this).data('shop-slug'),
        catalog_items: $(this).data('orderd-items'),
      }
    })
    .done(function(data) {
      e.stopPropagation();
      e.preventDefault();

      $('.js-agreement-in-bulk-modal').modaal('close');
      open_cart_in_bulk_modal(data);

      reload_cart_items();
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      if (textStatus === 'abort') return;
      close_agreement_in_bulk_modal();
      alert('正しく反映されませんでした。画面を更新してください。')
    });

    return false;
  });


  // クイックオーダー_同意必須モーダル_同意した上で買い物カゴに入れるで発火
  $('#modalAgreementInQuickOrder .js-agreement-in-bulk-button').on("click", function() {
    // 同意履歴の更新が終わるまで待つ
    $.when.apply(
      $, after_agreement($(this).data('agreement-required-item-codes'))
    ).done(function() {
      close_agreement_in_bulk_modal();
      $('form#quick_order').submit();
    })

    return false;
  });

  // 同意ボタンを表示するかの判定
  function skip_agreement(item) {
    return (item['product-description3'] == "")
  }

  // カートへの追加処理(名入れ、刺繍設定が両方存在することはない想定)
  function add_cart(item, via_agreement = true, target_modal=false, is_sample = false) {
    // サンプル商品の場合は名入れ・刺繍をスキップしてdefault処理のみ
    if (is_sample) {
      default_add_cart(item, via_agreement);
    } else if($('#enable_name_print').prop('checked')) {
      name_print_add_cart(item, via_agreement, target_modal);
    } else if ($('#enable_embroidery').prop('checked')) {
      embroidery_add_cart(item, via_agreement, target_modal);
    } else {
      default_add_cart(item, via_agreement);
    }
  }

  function default_add_cart(item, via_agreement = true) {
    $.ajax({
      type: 'POST',
      url: '/add_cart',
      data: {
        shop_slug: item['shop-slug'],
        catalog_item_cd: item['catalog-item-cd'],
        amount: item['amount']
      }
    })
    .done(function() {
      reload_cart_items();

      if ( via_agreement ) {
        after_agreement(new Array(item['catalog-item-cd']));
      }
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      if (textStatus === 'abort') return;
      close_agreement_modal();
      alert('正しく反映されませんでした。画面を更新してください。');
    });
  }

  function name_print_add_cart(item, via_agreement = true, target_modal=false) {
    const fd = new FormData();

    // 既存パラメータ
    fd.append('shop_slug', item['shop-slug']);
    fd.append('catalog_item_cd', item['catalog-item-cd']);
    fd.append('amount', item['amount']);

    const $form = $('#name_print_form');

    // HTMLのバリデーションに通っているか確認
    if(!namePrintFormHtmlValidation()){
      $(target_modal).html("<p>名入れ情報入力項目にエラーがあります。</p>").fadeIn();
    }

    // 1) 非ファイル要素はserializeArray()に任せる
    //    ・checkbox: チェック済みだけが含まれる
    //    ・radio: 選択済みだけが含まれる
    //    ・select[multiple]: 複数選択は複数エントリで返る
    //    ・name="xxx[]" もそのまま複数値として返る
    $form.find('input:not([type="file"]), select, textarea')
      .serializeArray()
      .forEach(({ name, value }) => {
        fd.append(name, value);
      });

    // 2) ファイル要素は個別に収集（multiple / name="xxx[]" 両対応）
    $form.find('input[type="file"]').each(function () {
      const el = this;
      const files = el.files || [];
      for (let i = 0; i < files.length; i++) {
        fd.append(el.name, files[i]);
      }
    });

    $.ajax({
      type: 'POST',
      url: '/add_cart',
      data: fd,
      processData: false, // FormDataをそのまま送る
      contentType: false  // multipart/form-data; boundary=... を自動設定
    })
    .done(function () {
      remove_name_print_errors()
      reload_cart_items();
      if (via_agreement) {
        after_agreement([item['catalog-item-cd']]);
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      if (textStatus === 'abort') return;
      // form_errorsはActiveModel::Errors準拠の構造で来る想定
      // keyはフィールドのid属性値、valueはエラーメッセージ配列
      // 例: {:name_print_input_304=>["を入力してください"], :name_print_input_305=>["は2MB以下にしてください", "はJPG, GIF, PNG, PDFにしてください"], ...}
      const form_errors = jqXHR.responseJSON && jqXHR.responseJSON.form_errors;

      // api_errors_full_messagesは Array[<Hash>]
      // 例：[{"message"=>"500 Internal Server Error"}]
      const api_errors_full_messages = jqXHR.responseJSON && jqXHR.responseJSON.api_errors_full_messages;

      if(api_errors_full_messages && 0 < Object.keys(api_errors_full_messages).length) {
        alert(api_errors_full_messages.join('、'));
      } else if(form_errors && 0 < Object.keys(form_errors).length) {
        // 既存のエラーメッセージを削除
        remove_name_print_errors()

        // エラーメッセージ表示
        display_name_print_errors(form_errors)

      } else {
        alert('正しく反映されませんでした。画面を更新してください。');
      }
    });
  }

  function embroidery_add_cart(item, via_agreement = true, target_modal=false) {
    const fd = new FormData();

    // 既存パラメータ
    fd.append('shop_slug', item['shop-slug']);
    fd.append('catalog_item_cd', item['catalog-item-cd']);
    fd.append('amount', item['amount']);

    const $form = $('#embroidery_form');

    // HTMLのバリデーションに通っているか確認
    if(embroideryFormHtmlValidation()){
      remove_embroidery_errors();
    } else {
      $(target_modal).html("<p>刺繍入力項目にエラーがあります。</p>").fadeIn();
      return;
    }
    // 各パターンのデータを追加
    $('.js-embroidery-pattern').each(function() {
      const $pattern = $(this);
      const patternIndex = $pattern.attr('data-pattern-index');
      const embroideryQuantityName = 'embroidery_position_sets[patterns][' + patternIndex + '][quantity]';
      const embroideryPositonName = 'embroidery_position_sets[patterns][' + patternIndex + '][positions][]';
      
      // 注文数
      const selectedQuantity = $pattern.find('[name="' + embroideryQuantityName + '"]');
      if (selectedQuantity.val() == '' || selectedQuantity.val() == '0') {
        return true;
      }
      fd.append(selectedQuantity.attr('name'), selectedQuantity.val());

      // チェックされた刺繍位置IDを配列で取得
      const checkedPositionIds = [];
      $pattern.find('input[name="' + embroideryPositonName + '"]:checked.js-tabCheckbox-trigger').each(function() {
        const positionId = $(this).val();
        checkedPositionIds.push(positionId);
      });
      
      // 刺繍位置以外の刺繍情報入力欄の値を収集
      $form.find('input:not([type="checkbox,number"]), select')
      .serializeArray()
      .forEach(({ name, value }) => {
        // nameが embroidery_position_sets[patterns][x][positions][XX][***_id] の形式で、XXが選択済みの刺繍位置に含まれるものだけをセットする
        const regex = new RegExp(`^embroidery_position_sets\\[patterns]\\[${patternIndex}]\\[positions]\\[(\\d+)]`);
        const match = name.match(regex);
        const embroiderySetting = match && match[0];
        const positionId = match && match[1];

        if (embroiderySetting && checkedPositionIds.includes(positionId)) { 
          fd.append(name, value);
        }
      });
    });

    $.ajax({
      type: 'POST',
      url: '/add_cart',
      data: fd,
      processData: false, // FormDataをそのまま送る
      contentType: false  // multipart/form-data; boundary=... を自動設定
    })
    .done(function () {
      remove_embroidery_errors()
      reload_cart_items();
      if (via_agreement) {
        after_agreement([item['catalog-item-cd']]);
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      if (textStatus === 'abort') return;
      // form_errorsはActiveModel::Errors準拠の構造で来る想定
      // keyはフィールドのid属性値、valueはエラーメッセージ配列
      // 例: {:embroidery_position_sets_patterns_1_positions_2_embroidery_font_id=>["を入力してください"], ...}
      const form_errors = jqXHR.responseJSON && jqXHR.responseJSON.form_errors;

      // api_errors_full_messagesは Array[<Hash>]
      // 例：[{"message"=>"500 Internal Server Error"}]
      const api_errors_full_messages = jqXHR.responseJSON && jqXHR.responseJSON.api_errors_full_messages;

      if(api_errors_full_messages && 0 < Object.keys(api_errors_full_messages).length) {
        alert(api_errors_full_messages.join('、'));
      } else if(form_errors && 0 < Object.keys(form_errors).length) {
        if(form_errors.exception) {
          remove_embroidery_errors()
          alert('正しく反映されませんでした。画面を更新してください。');
        } else {
          remove_embroidery_errors()
          display_embroidery_errors(form_errors)
        }
      } else {
        alert('正しく反映されませんでした。画面を更新してください。');
      }
    });
  }

  // 名入れフォームのHTMLのバリデーションに通っているか確認
  // 戻り値:true -> バリデーション成功
  // 戻り値:false -> バリデーション失敗
  function namePrintFormHtmlValidation() {
    const $form = $('#name_print_form');
    const form = document.getElementById("name_print_form")
    const first_name_print_definition_item_name_print_category_cd = $form.find(".name_print_definition_item_name_print_category_cd").eq(0).val();
    const first_name_print_definition_item_input_name_base = $form.find(".name_print_definition_item_input_name_base").eq(0).val();
    const first_name_print_input_name = first_name_print_definition_item_input_name_base + "[input_value]";
    // リピート購入のバリデーションスキップはラジオボタンの場合のみ対象
    const $checkedRadio = $form.find('input[type="radio"][name="' + first_name_print_input_name + '"]:checked');
    const first_name_print_input_input_value = $checkedRadio.length > 0
      ? $checkedRadio.val()
      : null;
    const repeat_purchase_name_print_category_cds = ["01", "03", "04", "05", "06", "07", "08", "09", "10", "11", "17", "18", "19"];

    if ( // リピート購入の場合はバリデーションをスキップ
      repeat_purchase_name_print_category_cds.includes(
        first_name_print_definition_item_name_print_category_cd
      ) &&
      first_name_print_input_input_value === "再注文（印刷内容変更なし）"
    ) {
      return true;
    }

    if (!form.checkValidity()) {
      return false;
    }

    // チェックボックスの必須チェック
    // required属性は「この要素自体がチェック必須」を意味するためチェックボックスには使用せず、
    // グループ判定用に先頭要素のみ data-group-required を付与し、name単位でグループ化して判定する
    const requiredCheckboxNames = new Set();
    $form.find('input[type="checkbox"][data-group-required]').each(function() {
      requiredCheckboxNames.add($(this).attr('name'));
    });
    for (const groupName of requiredCheckboxNames) {
      if ($form.find('input[type="checkbox"][name="' + groupName + '"]:checked').length === 0) {
        return false;
      }
    }

    // 各 input[type="file"] のサイズチェック
    const maxSize = 2 * 1024 * 1024; // 2MB (バイト単位)
    let isValid = true;
    $form.find('input[type="file"]').each(function () {
      const files = this.files;
      if (!files || files.length === 0) return; // 選択なしはスキップ

      for (let i = 0; i < files.length; i++) {
        const f = files[i];
        if (f.size > maxSize) {
          isValid = false;
          return false; // for files のループを抜ける
        }
      }

      if (!isValid) return false; // $form.find('input[type="file"]').each を抜ける
    });

    return isValid;
  }

  // 刺繍フォームのHTMLのバリデーションに通っているか確認
  // 戻り値:true -> バリデーション成功
  // 戻り値:false -> バリデーション失敗
  function embroideryFormHtmlValidation() {
    const form = document.getElementById("embroidery_form");
    // バリデーションエラーのあるフィールドを収集
    const form_errors = {};

    // 各パターンごとにバリデーションチェック
    $('.js-embroidery-pattern').each(function() {
      const $pattern = $(this);
      const patternIndex = $pattern.attr('data-pattern-index');
      const embroideryPositonName = 'embroidery_position_sets[patterns][' + patternIndex + '][positions][]';
      const checkedPositions = $pattern.find('input[name="' + embroideryPositonName + '"]:checked.js-tabCheckbox-trigger')
      
      // 刺繍位置が1つも選択されていない場合
      if (checkedPositions.length === 0) {
        const firstPositionId = $pattern.find('input[name="' + embroideryPositonName + '"].js-tabCheckbox-trigger').first().data('position-id');
        if (firstPositionId) {
          const key = `embroidery_position_sets_patterns_${patternIndex}_positions_${firstPositionId}`;
          form_errors[key] = ['を選択してください'];
        }
      }

      // チェックされた刺繍位置ごとに入力項目をチェック
      checkedPositions.each(function() {
        const positionId = $(this).data('position-id');
        const $panel = $pattern.find('.js-tabCheckbox-panel').filter(function() {
          return $(this).find(`[data-position-id="${positionId}"]`).length > 0;
        });
        
        // 必須フィールドのチェック
        $panel.find('select[required], input[required]:not([name="' + embroideryPositonName + '"])').each(function() {
          const $field = $(this);
          const fieldId = $field.attr('id');
          
          // disabled状態のフィールドはスキップ
          if ($field.prop('disabled')) {
            return;
          }
          
          if (!this.checkValidity()) {              
            if (this.validity.valueMissing) {
              const isSelect = $field.is('select');
              const message = isSelect ? 'を選択してください' : 'を入力してください';
              form_errors[fieldId] = [message];
            } else if (this.validity.tooLong) {
              const maxLength = $field.attr('maxlength');
              form_errors[fieldId] = [`は${maxLength}文字以内で入力してください`];
            } else {
              form_errors[fieldId] = ['の入力内容が正しくありません'];
            }
          }
        });

        // お名前のスペース除外文字数チェック
        $panel.find('input[required][data-max-length]').each(function() {
          const $field = $(this);
          const fieldId = $field.attr('id');

          if ($field.prop('disabled')) {
            return;
          }

          const maxLength = parseInt($field.attr('data-max-length'));
          const value = $field.val() || '';
          const lengthWithoutSpaces = value.replace(/[\s\u3000]/g, '').length;

          if (lengthWithoutSpaces > maxLength) {
            if (!form_errors[fieldId]) {
              form_errors[fieldId] = [`は${maxLength}文字以内で入力してください`];
            }
          }
        });
      });
    });

    // エラーがある場合は表示
    if (Object.keys(form_errors).length > 0) {
      remove_embroidery_errors();
      display_embroidery_errors(form_errors);
    } else {
      return true;
    }

    return false;
  }

  // 名入れフォームの既存のエラーメッセージを削除
  function remove_name_print_errors() {
    const $form = $("#name_print_form");

    $form.find(".form-error-txt:visible").remove();
    $form.find(".is-error").removeClass("is-error");
    $("#posError").hide();
  }

  // 名入れフォームのエラーメッセージ表示
  function display_name_print_errors(form_errors){
    const $form = $("#name_print_form");
    const deviceType = $form.data('device-type');
    
    if (deviceType === 'sp') {
      display_name_print_errors_sp(form_errors);
    } else {
      display_name_print_errors_pc(form_errors);
    }
  }

  function display_name_print_errors_pc(form_errors){
    $.each(form_errors, function(id, messages){
      const $field = $("#" + id);
      if ($field.length === 0) return;

      const display_title = $field.closest("tr").find(".form-table__ttl").text();
      const $org_error_txt = $field.find(".form-error-txt");

      $("#posError").show();
      $field.closest("div").addClass("is-error");

      messages.forEach(function(message){
        const $error_txt = $org_error_txt.clone();

        $error_txt.text(display_title + message);
        $error_txt.show();
        $field.prepend($error_txt);
      });
    });
  }

  function display_name_print_errors_sp(form_errors){
    $.each(form_errors, function(id, messages){
      const $field = $("#" + id);
      if ($field.length === 0) return;

      const display_title = $field.closest('dd').prev('dt').clone().find('.required').remove().end().text().trim();
      const $org_error_txt = $field.find(".form-error-txt");

      $("#posError").show();
      $field.closest("div").addClass("is-error");

      messages.forEach(function(message){
        const $error_txt = $org_error_txt.clone();

        $error_txt.text(display_title + message);
        $error_txt.show();
        $field.prepend($error_txt);
      });
    });
  }

  // 刺繍フォームの既存のエラーメッセージを削除
  function remove_embroidery_errors() {
    const $form = $("#embroidery_form");

    $form.find(".form-error-txt").empty().hide();
    $form.find(".is-error").removeClass("is-error");
    $("#posError").hide();
  }

  // 刺繍フォームのエラーメッセージ表示
  function display_embroidery_errors(form_errors){
    const $form = $("#embroidery_form");
    const deviceType = $form.data('device-type');
    
    if (deviceType === 'sp') {
      display_embroidery_errors_sp(form_errors);
    } else {
      display_embroidery_errors_pc(form_errors);
    }
  }

  function display_embroidery_errors_pc(form_errors){
    $.each(form_errors, function(id, messages){
      const $field = $("#" + id);
      if ($field.length === 0) return;

      const display_title = $field.closest("tr").find(".form-table__ttl").text();
      const $error_container = $field.closest("td").find(".form-error-txt");

      $("#posError").show();
      $field.closest("div").addClass("is-error");
      $field.addClass("is-error");

      if (messages.length > 0) {
        $error_container.text(display_title + messages.join(', '));
        $error_container.show();
      }
    });
  }

  function display_embroidery_errors_sp(form_errors){
    $.each(form_errors, function(id, messages){
      const $field = $("#" + id);
      if ($field.length === 0) return;

      const display_title = $field.closest('dd').prev('dt').text();
      const $error_container = $field.closest("dd").find(".form-error-txt");

      $("#posError").show();
      $field.closest("div").addClass("is-error");
      $field.addClass("is-error");

      if (messages.length > 0) {
        $error_container.text(display_title + messages.join(', '));
        $error_container.show();
      }
    });
  }

  // 同意が必要な商品のデータ
  function set_agreement_required_items($input_amounts) {
    let agreement_required_items = [];

    $input_amounts.each(function(i, e) {
      const amount = $(e).val();

      // 有効な注文数が存在する場合
      if (amount > 0) {
        const item = $(e).data('item');

        if ( !skip_agreement(item) ) {
          // 同意が必要な商品
          let agreement_required_item = {};

          agreement_required_item['catalog_item_cd'] = item['catalog-item-cd'];
          agreement_required_item['item_label'] = item['item-label'];
          agreement_required_item['product_description3'] = item['product-description3'];
          agreement_required_items.push(agreement_required_item);
        }
      }
    });

    return agreement_required_items;
  }

  // カートに入れる商品のデータの準備
  function set_orderd_items($input_amounts) {
    let orderd_items = [];

    $input_amounts.each(function(i, e) {
      const amount = $(this).val();

      // 有効な注文数が存在する場合
      if (amount > 0) {
        const item = $(e).data('item');
        let orderd_item = {};

        orderd_item['catalog_item_cd'] = item['catalog-item-cd'];
        orderd_item['size'] = item['size'];
        orderd_item['amount'] = amount;
        orderd_items.push(orderd_item);
      }
    });

    return orderd_items;
  }

  // 複数商品の同意文言準備
  function prepare_agreement_message_in_bulk(agreement_required_items) {
    // 同意の保存処理が必要な商品コードを data 属性にセット
    let agreement_required_item_codes = agreement_required_items.map( function(agreement_required_item) {
      return agreement_required_item['catalog_item_cd'];
    });

    $('.js-agreement-in-bulk-button').data('agreement-required-item-codes', agreement_required_item_codes);

    // モーダルに商品ごとの注意文言を追加
    let $dl = $("<dl />").addClass('modal-message__list');
    $.each(agreement_required_items, function(index, agreement_required_item) {
      $dl.append(`<dt class="modal-message__ttl">${agreement_required_item['item_label']}</dt>`);
      $dl.append(`<dd class="modal-message__data">${agreement_required_item['product_description3']}</dd>`);
    });
    $('.js-agreement-in-bulk-message').empty().append($dl);
  }

  // 同意後の処理
  function after_agreement(item_codes) {
    return $.map(item_codes, function(item_code, i) {
      // 同意済みのカタログ商品コードを配列に格納する
      agreed_catalog_item_cds.push(item_code);
      // 同意済みカタログ商品コードの重複を消す
      checked_duplicate_agreed_catalog_item_cds = $.unique(agreed_catalog_item_cds);
      return agree_catalog_item(item_code);
    });
  }

  // 同意するに保存
  function agree_catalog_item(catalog_item_cd) {
    var url = '/agree_catalog_item'
    return $.ajax({
      type: 'GET',
      url: url,
      data: { catalog_item_cd: catalog_item_cd },
    })
    .done(function (data) {
    })
    .fail(function (jqXHR, textStatus) {
      if (textStatus === 'abort') return;
      alert('正しく反映されませんでした。画面を更新してください。');
    });
  }

  // ヘッダー買い物カゴを更新
  function reload_cart_items() {
    var url = '/show_my_cart'
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
    })
    .done(function (data) {
      $('.js-reload-cart-items').html(data);
    })
    .fail(function (jqXHR, textStatus) {
      if (textStatus === 'abort') return;
      alert('正しく反映されませんでした。画面を更新してください。');
    });
  }

  // 再入荷申し込みボタン
  $(document).on('click', '.js-entry-restock', function() {
    const item = $(this).data('item');

    let url = '/back_order_notification_request';
    $.ajax({
      type: 'GET',
      url: url,
      data: { catalog_item_cd: item['catalog-item-cd'],
              shop_slug: item['shop-slug'] }
    })
    .fail(function (data) {
      close_restock_modal();
      alert('正しく反映されませんでした。画面を更新してください。');
    })
  });

  // 再入荷申し込みボタン
  $(document).on("click", '.js-restock-modal', function() {
    const item = $(this).data('item');

    load_restock(item);
  });

  function load_restock(item) {
    let url = '/back_order_notification_requestable';
    $.ajax({
      type: 'GET',
      url: url,
      data: { catalog_item_cd: item['catalog-item-cd'] }
    })
    .done(function (data) {
      if ( data == "false") {
        // 再入荷お知らせメールのお申込み完了モーダル
        const target = $('#modalRestockComplete').html();
        $(".modaal-content-container").html(target).fadeIn();
      } else {
        // 再入荷お知らせメールのお申込み完了モーダル
        $(".modal-item__name").text(item['catalog-item-name']);
        $(".modal-item__sub").text(item['product-description2']);
        $(".modal-item__capa").text(item['sales-unit-memo']);
        $(".modal-mail__data").text(item['email']);

        const target = $('#modalRestockEntry').html();
        $(".modaal-content-container").html(target).fadeIn();

        $('.js-entry-restock').data('item', item);
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      alert('正しく反映されませんでした。画面を更新してください。');
      $('.js-restock-modal').modaal('close');
    })
  }

  // ----------------------------------------
  // モーダル
  // ----------------------------------------
  $(function() {
    build_agreement_modal();
    build_restock_modal();

    // ajaxで取得するカセット初期化用のイベント
    // jQueryのイベント処理がうまく動かないのでJSでイベント定義
    document.addEventListener('cassette:init', (event) => {
      const target = event.detail.target;
      const cassette_options = $.extend(base_modal_options(), { before_open: onclick_add_cart });

      build_agreement_modal($(target), cassette_options);
      build_restock_modal($(target), cassette_options);
    });
  });

  //閉じるボタン
  $(document).on("click", ".js-modal-close", function() {
    close_restock_modal();
  });

  $(document).on("click", ".js-restock-modal-close", function() {
    close_restock_modal();
  });

  $(document).on("click", ".js-agreement-modal-close", function() {
    close_agreement_modal();
  });

  $(document).on("click", ".js-agreement-in-bulk-modal-close", function() {
    close_agreement_in_bulk_modal();
  });

  function base_modal_options() {
    const options = {
      overlay_opacity: "0.5",
      custom_class: "modal-wrap",
      hide_close: false,
      start_open: false,
    };

    return options;
  }

  // modaalが元のHTMLを上書きするので、それを抑制するための設定
  // モーダル開いた後に元のHTMLを戻して、閉じた後に追加されたHTMLを消す
  function non_destractive_options() {
    return {
      after_open: function(modal_wrapper) {
        const modaal_id = $(modal_wrapper).attr('id');
        const origin_place = $($('[data-modaal-scope="' + modaal_id + '"]').attr('href'));
        // 同じID持つ要素が複数あるが、modaalが`$('#{id}')`で処理対象取得しているので先頭のみ取得で問題ない
        $('#' + modaal_id + ' .modaal-content-container').contents().clone().appendTo(origin_place);
      },
      after_close: function() {
        $('.modal-hidden').children().each(function(i, elem) {
          $(elem).children(':not(:first)').remove();
        });
      }
    }
  }

  function build_restock_modal(scope = $(document), base_options = base_modal_options()) {
    const target = scope.find(".js-restock-modal");
    if (target.length) {
      const additonal_options = {
        after_close: function() {
          const target = $('#modalLoading').html();
          $("#modalRestock").html(target).fadeIn();
        }
      };
      const options = $.extend(base_options, additonal_options);

      target.modaal(options);
    }
  }

  function build_agreement_modal(scope = $(document), options = base_modal_options()) {
    const target = scope.find(".js-agreement-modal");
    if (target.length) {

      target.modaal($.extend(options, non_destractive_options()));
    }
  }

  function open_agreement_in_bulk_modal() {
    const options = base_modal_options();

    $('.js-agreement-in-bulk-modal').modaal(options);
    $('.js-agreement-in-bulk-modal').click();
  }

  function open_cart_in_bulk_modal(data) {
    const options = base_modal_options();

    $('.modal-item-order').html(data);
    $('.js-cart-in-bulk-modal').modaal(options);
    $('.js-cart-in-bulk-modal').click();
  }

  function close_restock_modal() {
    if ($(".js-restock-modal").length) {
      $('.js-restock-modal').modaal('close');
    }
  }

  function close_agreement_modal() {
    if ($(".js-agreement-modal").length) {
      $('.js-agreement-modal').modaal('close');
    }
  }

  function close_agreement_in_bulk_modal() {
    // 同意画面
    if ($(".js-agreement-in-bulk-modal").length) {
      $('.js-agreement-in-bulk-modal').modaal('close');
    }
    // カートに追加画面
    if ($(".js-cart-in-bulk-modal").length) {
      $('.js-cart-in-bulk-modal').modaal('close');
    }
  }
}
